import { Modal } from "react-bootstrap";
import cardIcon from "../../../../images/credit-card-solid.png";
import ErrorAlert from "../../../../common/ui/ErrorAlert";
import VoucherList from "./VoucherList";

export default function VouchersModalPage(props) {
    const formData = props.loyaltyMember.VoucherModalPage;
    let voucherIssueIdInCart = props.loyaltyMember.VoucherDetails.VoucherIssueId;

    return (
        <>
            <div className="modal-header justify-content-start">
                <h1 className="modal-title fs-5 text-break">Hi, {props.loyaltyMember.MenuNav.LoyaltyMemberButtonValue}</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleClickCloseLoyaltyModal}></button>
            </div>
            <Modal.Body>
                <div className="d-flex flex-sm-row flex-column justify-content-between align-items-center">
                    <span className="fs-5 fw-medium">
                        Available rewards
                    </span>
                    <span className="badge text-bg-light text-dark-emphasis align-items-center mt-sm-0 mt-2">
                        <img src={cardIcon} alt="Card Number" title="Card Number" style={{width: "15px"}}></img>
                        &emsp;<span>{props.loyaltyMember.MenuNav.CardNumber}</span>
                    </span>
                </div>
                { formData.ShowVouchersLoading ? 
                    <VoucherLoader /> : 
                    <VoucherList 
                        vouchers={formData.Vouchers} 
                        handleSelectVoucher={props.handleSelectVoucher}
                        voucherIssueIdInCart={voucherIssueIdInCart}
                    /> 
                }
                <div className="row justify-content-center mx-0 mt-4 mb-2">
                    { formData.GeneralError.HasError && 
                    <div className="col-sm-10 col-12 mb-4">
                        <ErrorAlert message={formData.GeneralError.ErrorMessage} />
                    </div> }
                    <div className="col-sm-10 col-12 justify-content-center">
                        <button type="button" className="btn btn-outline-dark rounded-pill w-100" onClick={props.handleLoyaltyLogout} disabled={formData.GeneralError.ButtonsDisabled}>
                            Logout
                            { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </>
    )
}

function VoucherLoader() {
    return (
        <div className="mt-3 border rounded p-2">
            <span className="col-8 placeholder placeholder-wave bg-secondary"></span>
            <span className="col-6 placeholder placeholder-wave bg-secondary"></span>
        </div>
    )
}
